import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

export type Size = 'half' | 'third' | 'quarter' | 'fit' | 'full' | 'hug';
export type Resolution = 'xs' | 's' | 'm' | 'l' | 'desktop';

const options: { [size in Size]: string } = {
    half: '2',
    third: '3',
    quarter: '4',
    fit: 'fit',
    full: 'full',
    hug: 'hug',
};

const screenResolutionPrefixes: { [r in Resolution]: string } = {
    xs: 'xs-',
    s: 's-',
    m: 'm-',
    l: 'l-',
    desktop: '',
};

GridItem.propTypes = {
    xs: PropTypes.oneOf(Object.keys(options)),
    s: PropTypes.oneOf(Object.keys(options)),
    m: PropTypes.oneOf(Object.keys(options)),
    l: PropTypes.oneOf(Object.keys(options)),
    desktop: PropTypes.oneOf(Object.keys(options)),
};

export type Props = {
    [resolution in Resolution]?: Size;
};

export function GridItem({ children, ...resolutions }: Props & { children?: React.ReactNode }) {
    const classes = (Object.entries(resolutions as any) as [Resolution, Size][])
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .filter(([_resolution, size]) => !!size)
        .map(([resolution, size]) => `${screenResolutionPrefixes[resolution]}cols--${options[size]}`);

    return <div className={classNames('grid-item', classes)}>{children}</div>;
}
